import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import RoleCollection from "../role/RoleCollection";
import TutorialCategory from "@/assets/js/models/tutorial/TutorialCategory";
import JsonMappedModel from "@/assets/js/models/helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Tutorial extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Tutorial.id_attribute_name]: null,
      [Tutorial.tutorial_title_attribute_name]: null,
      [Tutorial.tutorial_description_attribute_name]: null,
      [Tutorial.tutorial_video_attribute_name]: null,
      [Tutorial.tutorial_category_attribute_name]: TutorialCategory,
      [Tutorial.tutorial_audience_attribute_name]: RoleCollection,
      [Tutorial.on_startup_attribute_name]: false,
      [Tutorial.language_attribute_name]: 'en'
    });
    _defineProperty(this, "loading", {
      content: false
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getLanguageAttributeName() {
    return this.language_attribute_name;
  }
  static getTitleAttributeName() {
    return this.tutorial_title_attribute_name;
  }
  static getVideoAttributeName() {
    return this.tutorial_video_attribute_name;
  }
  static getOnStartupAttributeName() {
    return this.on_startup_attribute_name;
  }
  static getDescriptionAttributeName() {
    return this.tutorial_description_attribute_name;
  }
  static getAudienceAttributeName() {
    return this.tutorial_audience_attribute_name;
  }
  static getCategoryAttributeName() {
    return this.tutorial_category_attribute_name;
  }
  isLoading() {
    return this.loading.content;
  }
  startLoading() {
    this.loading.content = true;
    return this;
  }
  endLoading() {
    this.loading.content = false;
    return this;
  }
  getTitle() {
    return this.getAttribute(Tutorial.tutorial_title_attribute_name);
  }
  getVideo() {
    return this.getAttribute(Tutorial.tutorial_video_attribute_name);
  }
  getDescription() {
    return this.getAttribute(Tutorial.tutorial_description_attribute_name);
  }
  getYoutubeVideoEmbed() {
    var _url$searchParams$get;
    let url = new URL(this.getVideo());
    url = (_url$searchParams$get = url.searchParams.get('v')) !== null && _url$searchParams$get !== void 0 ? _url$searchParams$get : url.pathname.replace('/', '');
    return `//www.youtube.com/embed/${url}`;
  }
  getYoutubeVideoImage() {
    var _url$searchParams$get2;
    let url = new URL(this.getVideo());
    url = (_url$searchParams$get2 = url.searchParams.get('v')) !== null && _url$searchParams$get2 !== void 0 ? _url$searchParams$get2 : url.pathname.replace('/', '');
    return `https://img.youtube.com/vi/${url}/default.jpg`;
  }
}
_defineProperty(Tutorial, "id_attribute_name", 'tutorial_id');
_defineProperty(Tutorial, "tutorial_title_attribute_name", 'tutorial_title');
_defineProperty(Tutorial, "tutorial_description_attribute_name", 'tutorial_description');
_defineProperty(Tutorial, "tutorial_video_attribute_name", 'tutorial_video');
_defineProperty(Tutorial, "tutorial_category_attribute_name", 'tutorial_category');
_defineProperty(Tutorial, "tutorial_audience_attribute_name", 'tutorial_audience');
_defineProperty(Tutorial, "on_startup_attribute_name", 'on_startup');
_defineProperty(Tutorial, "language_attribute_name", 'language');